import { FormControl, Select, MenuItem } from "@mui/material";
import { useStyles } from "./styles";
import PropTypes from "prop-types";

const Dropdown = ({
  Id,
  setDropdownValue,
  dataTestid,
  isNavbarOpen,
  value,
  label,
  ...props
}) => {
  const classes = useStyles({ isNavbarOpen });
  return (
    <FormControl
      data-testid={dataTestid || "dropDownFormControl"}
      className={classes.form}
      size="small"
    >
      <Select
        data-testid="dropDownSelect"
        sx={{
          backgroundColor: (theme) => theme.palette.bgColor,
          textAlign: "left",
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
          },
          ".MuiOutlinedInput-input": {
            padding: "7px",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
          },
          ".MuiSvgIcon-root": {
            fill: (theme) => theme.palette.text.primary,
            fontSize: "1.4vw",
          },
          fontSize: "0.8rem",
          height: "2.4rem",
          alignItems: "center",
          display: "flex",
        }}
        labelId="select-outlined-label"
        id={props.Id}
        value={props?.value || ""}
        onChange={(event) => setDropdownValue(event)}
        displayEmpty
        renderValue={() => {
          const selectedItem = props.lists.find((i) => i.Name === value);
          return selectedItem ? `Sort By ${selectedItem.Name}` : "Sort By";
        }}
      >
        {props.lists.map((item) => (
          <MenuItem
            data-testid="dropDownMenuItem"
            key={item.Id}
            value={item.Name}
          >
            {item.Name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
Dropdown.propTypes = {
  dataTestid: PropTypes.string,
  isNavbarOpen: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  lists: PropTypes.array,
  Id: PropTypes.any,
  setDropdownValue: PropTypes.func,
};
export default Dropdown;
